const initialState = {
  loading: false,
  minPresale: 0,
  maxPresale: 0,
  walletBalance: 0,
  hardCap: 0,
  cost: 0,
  state: 0,
  raised: 0,
  state: 0,
  loaded: false,
  error: false,
  errorMsg: "",
  contribution: 0,
  pool: {},
  isInit: false,
  isFinish: false,
  isRefund: false,
  claimRound: 0,
  claims: {},
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHECK_DATA_REQUEST":
      return {
        ...state,
        loading: true,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_SUCCESS":
      return {
        ...state,
        loading: false,
        walletBalance: action.payload.walletBalance,
        contribution: action.payload.contribution,
        raised: action.payload.raised,
        pool: action.payload.pool,
        isInit: action.payload.isInit,
        isFinish: action.payload.isFinish,
        isRefund: action.payload.isRefund,
        state: action.payload.state,
        claimRound: action.payload.claimRound,
        claims: action.payload.claims,
        loaded: true,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_FAILED":
      return {
        ...initialState,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default dataReducer;
